import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  label,
  error,
  icon,
  type,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-2942" data-mp="1x7mb4zfsg99u">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-2943" data-mp="zl6shubml5kp">
            {label}
          </label>}
        <div className="relative" data-id="element-2944" data-mp="14kjfcf2hycna">
          {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400" data-id="element-2945" data-mp="19j32ujwqnwhr">
              {icon}
            </div>}
          <input type={type} className={cn('flex h-11 w-full rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-amber disabled:cursor-not-allowed disabled:opacity-50', icon && 'pl-10', error && 'border-red-500 focus-visible:ring-red-500', className)} ref={ref} {...props} data-id="element-2946" data-mp="1dlret0gr1jiy" />
        </div>
        {error && <p className="mt-1.5 text-sm text-red-500" data-id="element-2947" data-mp="232xwagyzf2e7">{error}</p>}
      </div>;
});
Input.displayName = 'Input';
export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  className,
  label,
  error,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-2948" data-mp="1obyt5lgx1620">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-2949" data-mp="1kbesi7x4vkb4">
            {label}
          </label>}
        <textarea className={cn('flex min-h-[80px] w-full rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 transition-colors placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-amber disabled:cursor-not-allowed disabled:opacity-50', error && 'border-red-500 focus-visible:ring-red-500', className)} ref={ref} {...props} data-id="element-2950" data-mp="1fdvdh5sm33i4" />
        {error && <p className="mt-1.5 text-sm text-red-500" data-id="element-2951" data-mp="1ogr3k5p0qltz">{error}</p>}
      </div>;
});
Textarea.displayName = 'Textarea';